var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6677 24.0852L20.7627 19.1803C23.2289 15.9743 22.9823 11.3434 20.0229 8.41136C18.4062 6.79465 16.3236 6 14.2137 6C12.1038 6 10.0212 6.79465 8.40451 8.41136C5.1985 11.6174 5.1985 16.8237 8.40451 20.0297C10.0212 21.6465 12.1038 22.4411 14.2137 22.4411C15.9674 22.4411 17.7211 21.8931 19.1734 20.7696L24.1058 25.6471C24.325 25.8663 24.599 25.9759 24.9004 25.9759C25.1744 25.9759 25.4759 25.8663 25.6951 25.6471C26.1061 25.2361 26.1061 24.5236 25.6677 24.0852ZM14.2411 20.2216C12.6244 20.2216 11.1447 19.5913 9.99382 18.4678C7.66466 16.1387 7.66466 12.3298 9.99382 9.97327C11.1173 8.84979 12.6244 8.21955 14.2411 8.21955C15.8578 8.21955 17.3375 8.84979 18.4884 9.97327C19.6393 11.0967 20.2421 12.6038 20.2421 14.2206C20.2421 15.8373 19.6119 17.317 18.4884 18.4678C17.3649 19.6187 15.8304 20.2216 14.2411 20.2216Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.7d013698528d46b088f0b1b889609d9f.svg";
export { ForwardRef as ReactComponent };